import { Component, OnDestroy, inject } from "@angular/core";
import {
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";
import { DialogHeaderComponent } from "@app/view/shared/dialog-header/dialog-header.component";
import { Store, select } from "@ngrx/store";
import { selectorAuth } from "@app/core";
import { Subscription } from "rxjs";

/**
 * Warns that a resource efficiency change won't reach the running solver until
 * the solve state is reloaded from the database. Mirrors the zone/skill change
 * confirmation dialogs. (#1512)
 */
@Component({
  selector: "app-confirm-efficiency-changes-dialog",
  templateUrl: "./confirm-efficiency-changes-dialog.component.html",
  styleUrls: ["./confirm-efficiency-changes-dialog.component.scss"],
  imports: [
    DialogHeaderComponent,
    CdkScrollable,
    MatDialogContent,
    MatIcon,
    MatDialogActions,
    MatButton
  ]
})
export class ConfirmEfficiencyChangesDialogComponent implements OnDestroy {
  private dialogRef =
    inject<MatDialogRef<ConfirmEfficiencyChangesDialogComponent>>(MatDialogRef);
  private store = inject<Store<any>>(Store);

  isAdmin = false;
  private authSubscription: Subscription;

  constructor() {
    this.authSubscription = this.store
      .pipe(select(selectorAuth))
      .subscribe((auth) => {
        this.isAdmin = !!auth && auth.isAdmin;
      });
  }

  ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
